import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-744876e9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "flex flex-col gap-y-8 mx-auto border-x border-slate-50 border-indigo-500",
    style: { "width": "100%", "padding-left": "15px", "padding-bottom": "60px", "background": "#f9fafb", "height": "100%" }
};
const _hoisted_2 = { class: "items-center" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, " Yield Codes ", -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-plus-circle",
    style: { "font-size": "1.5rem" }
}, null, -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "font-weight": "700" } }, " Add Yield Code ", -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-pen-to-square",
    style: { "font-size": "1.5rem" }
}, null, -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-trash",
    style: { "font-size": "1.5rem" }
}, null, -1));
const _hoisted_8 = { class: "flex items-center w-full" };
const _hoisted_9 = { class: "flex-none flex items-center gap-3" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "continue-label cursor-pointer",
    for: "create-more"
}, "Continue editing yield code and testing yield rules", -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "grow" }, null, -1));
const _hoisted_12 = { class: "flex-none flex items-center gap-3" };
const _hoisted_13 = { class: "flex items-center w-full" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "grow" }, null, -1));
const _hoisted_15 = { class: "flex-none flex items-center gap-3" };
import { computed, ref } from 'vue';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Checkbox from 'primevue/checkbox';
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
import { useConfirm } from 'primevue/useconfirm';
import { useToast } from 'primevue/usetoast';
import axios from 'axios';
import Modal from '@apparatix/Components/Modal.vue';
import PricingRateCode from '@apparatix/Components/PricingRateCode.vue';
import FormSkeleton from '@apparatix/Components/FormSkeleton.vue';
import PricingRateCodeAssignment from '@apparatix/Components/PricingRateCodeAssignment.vue';
const TOAST_LIFE = 3000;
export default /*#__PURE__*/ _defineComponent({
    __name: 'YieldCodeOverview',
    props: {
        rateCodes: {}
    },
    setup(__props) {
        const props = __props;
        const rateCodeArray = ref(JSON.parse(props.rateCodes));
        const confirm = useConfirm();
        const toast = useToast();
        const modalVisible = ref(false);
        const assignFaceModalVisible = ref(false);
        const modalFormRef = ref();
        const action = ref(null);
        const isLoading = ref(false);
        const yieldCodeViewModel = ref();
        const previousState = ref();
        const selectedRow = ref({ name: '', id: undefined, rowId: undefined });
        const continueAfterSave = ref(true);
        const recordId = ref();
        const yieldCodeName = ref();
        const yieldCodeDescription = ref();
        const rulesToSave = ref([]);
        const assignedSet = ref(new Set());
        const unassignedSet = ref(new Set());
        const shouldShowYieldCodeComponent = computed(() => {
            if (isLoading.value)
                return false;
            if (!action.value)
                return false;
            if (!yieldCodeViewModel.value)
                return false;
            return true;
        });
        const updateViewModel = (newValues) => {
            yieldCodeViewModel.value = { ...yieldCodeViewModel.value, ...newValues };
        };
        const updatePreviousState = (newValues) => {
            previousState.value = { ...previousState.value, ...newValues };
        };
        const modalHeaderText = computed(() => {
            if (!action.value)
                return null;
            return action.value === 'create' ? 'Create Yield Code' : 'Edit Yield Code';
        });
        const canSubmit = computed(() => yieldCodeName.value && rulesToSave.value.length > 0);
        const hasEditMadeChanges = computed(() => {
            if (action.value === 'create' || !yieldCodeViewModel.value)
                return false;
            if (rulesToSave.value.length !== previousState.value?.rules?.length) {
                return true;
            }
            let haveRulesChanged = false;
            previousState.value.rules.forEach((rule, idx) => {
                if (rule.id !== rulesToSave.value[idx].id) {
                    haveRulesChanged = true;
                }
            });
            return haveRulesChanged;
        });
        const shouldDisableEdit = computed(() => {
            if (!yieldCodeName.value || rulesToSave.value.length === 0)
                return true;
            return false;
        });
        const onClose = () => cleanup();
        const onCreateClick = async () => {
            isLoading.value = true;
            modalVisible.value = true;
            action.value = 'create';
            const data = await axios.get('/pricingRateCodes/create?returnJson=true');
            if (data) {
                isLoading.value = false;
                updateViewModel(data.data);
                updatePreviousState({
                    name: '',
                    description: '',
                    rules: [],
                });
            }
        };
        const onEditClick = async (rateCode) => {
            modalVisible.value = true;
            action.value = 'edit';
            isLoading.value = true;
            selectedRow.value = { id: rateCode.id, name: rateCode.name, rowId: 0 };
            const data = await axios.get(`/pricingRateCodes/${selectedRow.value.id}?returnJson=true`);
            if (data.status !== 200) {
                const message = data.data?.message ?? 'Something went wrong';
                toast.add({ severity: 'error', summary: 'Error', detail: message, life: TOAST_LIFE });
            }
            const { selectedRules, pricingRateCode } = data.data;
            if (data?.data) {
                isLoading.value = false;
                recordId.value = data.data.pricingRateCode.id;
                updateViewModel(data.data);
                updatePreviousState({
                    name: pricingRateCode.name,
                    description: pricingRateCode.description,
                    rules: selectedRules,
                });
            }
        };
        const onAssignClick = async (rateCode) => {
            selectedRow.value = { id: rateCode.id, name: rateCode.name, rowId: 0 };
            assignFaceModalVisible.value = true;
        };
        const deleteCode = async () => {
            try {
                const result = await axios.delete(`/pricingRateCodes/${selectedRow.value.id}`);
                if (result.status === 200) {
                    rateCodeArray.value = rateCodeArray.value.filter(code => code.id !== selectedRow.value.id);
                    toast.add({ severity: 'success', summary: 'Success', detail: 'Code successfully deleted', life: TOAST_LIFE });
                }
                else {
                    toast.add({ severity: 'error', summary: 'Error', detail: 'Error deleting code', life: TOAST_LIFE });
                }
            }
            catch (error) {
                console.log('caught error', error);
                if (error.response?.data?.message === 'THIS YIELD CODE IS CURRENTLY IN USE') {
                    toast.add({
                        severity: 'error',
                        summary: 'Yield Code in use',
                        detail: 'This yield code is currently assigned to a face, and cannot be deleted. If you want to delete this code, first unassign this code from any faces',
                    });
                }
                else {
                    toast.add({ severity: 'error', summary: 'Error', detail: 'Error deleting code', life: TOAST_LIFE });
                }
            }
        };
        const onDeleteClick = (rateCode) => {
            selectedRow.value = { id: rateCode.id, name: rateCode.name, rowId: 0 };
            confirm.require({
                message: 'Are you sure you want to delete this yield code?',
                header: 'Confirm delete',
                rejectLabel: 'Cancel',
                acceptLabel: 'Delete',
                accept: () => deleteCode(),
            });
        };
        const onSave = async (openAssignModal = false) => {
            let success = false;
            const payload = {
                name: yieldCodeName.value,
                description: yieldCodeDescription.value,
                rules: rulesToSave.value,
            };
            if (!recordId.value) {
                const result = await axios.post('/pricingRateCodes/', payload);
                if (result?.data?.id) {
                    recordId.value = result.data.id;
                    rateCodeArray.value.push({ id: result.data.id, name: yieldCodeName.value, description: yieldCodeDescription.value });
                    success = true;
                }
            }
            else {
                payload.id = recordId.value;
                const result = await axios.put(`/pricingRateCodes/${recordId.value}`, payload);
                if (result.status === 200) {
                    success = true;
                    const changedCodeIndex = rateCodeArray.value.findIndex(code => code.id === recordId.value);
                    rateCodeArray.value[changedCodeIndex].name = yieldCodeName.value;
                    rateCodeArray.value[changedCodeIndex].description = yieldCodeDescription.value;
                    toast.add({ severity: 'success', summary: 'Success', detail: 'Code saved', life: TOAST_LIFE });
                }
                else {
                    const message = result.data?.message ?? 'Something went wrong';
                    toast.add({ severity: 'error', summary: 'Error', detail: message, life: TOAST_LIFE });
                }
            }
            if (success && continueAfterSave.value) {
                action.value = 'edit';
                updatePreviousState({
                    name: payload.name,
                    description: payload.description,
                    rules: payload.rules,
                });
            }
            if (!continueAfterSave.value || openAssignModal) {
                cleanup();
                if (openAssignModal) {
                    onAssignClick({ id: payload.id, name: payload.name, rowId: 0 });
                }
            }
            if (modalFormRef.value) {
                modalFormRef.value.relevantDataPoints = {};
                modalFormRef.value.listOfRelevantActions = {};
                modalFormRef.value.selectedFace = {};
            }
        };
        const onAssignFaceClick = (event) => {
            const message = `Assigning ${assignedSet.value.size} faces and unassigning ${unassignedSet.value.size} faces.`;
            if (assignedSet.value.size === 0 && unassignedSet.value.size === 0) {
                cleanup();
                return;
            }
            confirm.require({
                target: event.currentTarget,
                message: message,
                header: 'Are you sure?',
                accept: () => onAssignFaces(),
                position: 'center',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Ok',
                rejectLabel: 'Cancel',
                acceptClass: 'button-blue',
                rejectClass: 'text-blue',
            });
        };
        const onAssignFaces = async () => {
            const payload = {
                assignedFaces: [...assignedSet.value],
                unassignedFaces: [...unassignedSet.value],
            };
            payload.id = selectedRow.value.id;
            const result = await axios.put('/pricingAssignCodes', payload);
            if (result.status === 200) {
                toast.add({ severity: 'success', summary: 'Success', detail: 'Faces Assigned', life: TOAST_LIFE });
            }
            else {
                const message = result.data?.message ?? 'Something went wrong';
                toast.add({ severity: 'error', summary: 'Error', detail: message, life: TOAST_LIFE });
            }
            cleanup();
        };
        const cleanup = () => {
            action.value = undefined;
            yieldCodeViewModel.value = undefined;
            rulesToSave.value = [];
            yieldCodeName.value = undefined;
            yieldCodeDescription.value = undefined;
            recordId.value = undefined;
            continueAfterSave.value = true;
            modalVisible.value = false;
            isLoading.value = false;
            previousState.value = {};
            assignFaceModalVisible.value = false;
            assignedSet.value.clear();
            unassignedSet.value.clear();
        };
        return (_ctx, _cache) => {
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("section", _hoisted_1, [
                    _createVNode(_unref(DataTable), {
                        "striped-rows": "",
                        value: rateCodeArray.value,
                        class: "p-datatable-sm"
                    }, {
                        header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _hoisted_3,
                                _withDirectives((_openBlock(), _createBlock(_unref(Button), {
                                    size: "small",
                                    rounded: "",
                                    outlined: "",
                                    style: { "background": "#2B9C74", "color": "white" },
                                    onClick: _cache[0] || (_cache[0] = ($event) => (onCreateClick()))
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_4,
                                        _createTextVNode(),
                                        _hoisted_5
                                    ]),
                                    _: 1
                                })), [
                                    [
                                        _directive_tooltip,
                                        'Create a New Yield Code',
                                        void 0,
                                        { left: true }
                                    ]
                                ])
                            ])
                        ]),
                        empty: _withCtx(() => [
                            _createTextVNode(" No Codes found. ")
                        ]),
                        default: _withCtx(() => [
                            _createVNode(_unref(Column), {
                                field: "name",
                                header: "Name"
                            }),
                            _createVNode(_unref(Column), {
                                field: "description",
                                header: "Description"
                            }),
                            _createVNode(_unref(Column), { style: { "width": "80px" } }, {
                                body: _withCtx((slotProps) => [
                                    _withDirectives(_createVNode(_unref(Button), {
                                        size: "small",
                                        severity: "info",
                                        rounded: "",
                                        outlined: "",
                                        label: "Assign",
                                        onClick: ($event) => (onAssignClick(slotProps.data))
                                    }, null, 8, ["onClick"]), [
                                        [
                                            _directive_tooltip,
                                            'Assign Code To Faces',
                                            void 0,
                                            { left: true }
                                        ]
                                    ])
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(Column), { style: { "width": "20px" } }, {
                                body: _withCtx((slotProps) => [
                                    _withDirectives((_openBlock(), _createBlock(_unref(Button), {
                                        size: "small",
                                        severity: "info",
                                        class: "icon-button",
                                        style: { "color": "#2FA3EE" },
                                        rounded: "",
                                        outlined: "",
                                        onClick: ($event) => (onEditClick(slotProps.data))
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_6
                                        ]),
                                        _: 2
                                    }, 1032, ["onClick"])), [
                                        [
                                            _directive_tooltip,
                                            'Edit Code',
                                            void 0,
                                            { left: true }
                                        ]
                                    ])
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(Column), { style: { "width": "20px" } }, {
                                body: _withCtx((slotProps) => [
                                    _withDirectives((_openBlock(), _createBlock(_unref(Button), {
                                        size: "small",
                                        severity: "danger",
                                        class: "icon-button",
                                        style: { "color": "#E11D48" },
                                        rounded: "",
                                        outlined: "",
                                        onClick: ($event) => (onDeleteClick(slotProps.data))
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_7
                                        ]),
                                        _: 2
                                    }, 1032, ["onClick"])), [
                                        [
                                            _directive_tooltip,
                                            'Delete Code',
                                            void 0,
                                            { left: true }
                                        ]
                                    ])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["value"])
                ]),
                _createVNode(Modal, {
                    position: "top",
                    visible: modalVisible.value,
                    title: modalHeaderText.value,
                    subtitle: selectedRow.value.name,
                    icon: "circlePlus",
                    "on-close": onClose,
                    padding: "0"
                }, {
                    body: _withCtx(() => [
                        (isLoading.value)
                            ? (_openBlock(), _createBlock(FormSkeleton, { key: 0 }))
                            : _createCommentVNode("", true),
                        (shouldShowYieldCodeComponent.value)
                            ? (_openBlock(), _createBlock(PricingRateCode, {
                                key: 1,
                                ref_key: "modalFormRef",
                                ref: modalFormRef,
                                "yield-code-name": yieldCodeName.value,
                                "onUpdate:yieldCodeName": _cache[1] || (_cache[1] = ($event) => ((yieldCodeName).value = $event)),
                                "yield-code-description": yieldCodeDescription.value,
                                "onUpdate:yieldCodeDescription": _cache[2] || (_cache[2] = ($event) => ((yieldCodeDescription).value = $event)),
                                "rules-to-save": rulesToSave.value,
                                "onUpdate:rulesToSave": _cache[3] || (_cache[3] = ($event) => ((rulesToSave).value = $event)),
                                "face-list": yieldCodeViewModel.value.faceList,
                                "pricing-rules": yieldCodeViewModel.value.pricingRules,
                                "selected-rules": yieldCodeViewModel.value.selectedRules,
                                "pricing-rate-code": yieldCodeViewModel.value.pricingRateCode,
                                "record-id": recordId.value,
                                "is-dirty": hasEditMadeChanges.value,
                                "new-id": recordId.value
                            }, null, 8, ["yield-code-name", "yield-code-description", "rules-to-save", "face-list", "pricing-rules", "selected-rules", "pricing-rate-code", "record-id", "is-dirty", "new-id"]))
                            : _createCommentVNode("", true)
                    ]),
                    footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(_unref(Checkbox), {
                                    modelValue: continueAfterSave.value,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((continueAfterSave).value = $event)),
                                    "input-id": "create-more",
                                    binary: true
                                }, null, 8, ["modelValue"]),
                                _hoisted_10
                            ]),
                            _hoisted_11,
                            _createElementVNode("div", _hoisted_12, [
                                _createVNode(_unref(Button), {
                                    label: "Cancel",
                                    class: "justify-self-end",
                                    severity: "secondary",
                                    onClick: onClose
                                }),
                                (action.value === 'edit')
                                    ? (_openBlock(), _createBlock(_unref(Button), {
                                        key: 0,
                                        label: "Save and Assign",
                                        class: "justify-self-end",
                                        disabled: shouldDisableEdit.value,
                                        onClick: _cache[5] || (_cache[5] = ($event) => (onSave(true)))
                                    }, null, 8, ["disabled"]))
                                    : _createCommentVNode("", true),
                                (action.value === 'create')
                                    ? (_openBlock(), _createBlock(_unref(Button), {
                                        key: 1,
                                        label: "Create",
                                        class: "justify-self-end",
                                        disabled: !canSubmit.value,
                                        onClick: _cache[6] || (_cache[6] = ($event) => (onSave()))
                                    }, null, 8, ["disabled"]))
                                    : _createCommentVNode("", true),
                                (action.value === 'edit')
                                    ? (_openBlock(), _createBlock(_unref(Button), {
                                        key: 2,
                                        label: "Save",
                                        class: "justify-self-end",
                                        disabled: shouldDisableEdit.value,
                                        onClick: _cache[7] || (_cache[7] = ($event) => (onSave()))
                                    }, null, 8, ["disabled"]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["visible", "title", "subtitle"]),
                _createVNode(Modal, {
                    position: "top",
                    visible: assignFaceModalVisible.value,
                    title: "Assign Yield Code",
                    subtitle: selectedRow.value.name,
                    icon: "circlePlus",
                    "on-close": onClose,
                    padding: "0"
                }, {
                    body: _withCtx(() => [
                        _createVNode(PricingRateCodeAssignment, {
                            "yield-code": selectedRow.value,
                            "onUpdate:yieldCode": _cache[8] || (_cache[8] = ($event) => ((selectedRow).value = $event)),
                            "assigned-set": assignedSet.value,
                            "onUpdate:assignedSet": _cache[9] || (_cache[9] = ($event) => ((assignedSet).value = $event)),
                            "unassigned-set": unassignedSet.value,
                            "onUpdate:unassignedSet": _cache[10] || (_cache[10] = ($event) => ((unassignedSet).value = $event))
                        }, null, 8, ["yield-code", "assigned-set", "unassigned-set"])
                    ]),
                    footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("div", _hoisted_15, [
                                _createVNode(_unref(Button), {
                                    label: "Cancel",
                                    class: "justify-self-end",
                                    severity: "secondary",
                                    onClick: onClose
                                }),
                                _createVNode(_unref(Button), {
                                    label: "Assign Faces",
                                    class: "justify-self-end",
                                    onClick: onAssignFaceClick
                                })
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["visible", "subtitle"]),
                _createVNode(_unref(ConfirmDialog)),
                _createVNode(_unref(Toast))
            ], 64));
        };
    }
});
